var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-img"},[_c('img',{staticClass:"round w-full img-checkin",attrs:{"src":this.params.data.imageUrl ? this.params.data.urlImage : _vm.imageDefault}})])
}
var staticRenderFns = []

export { render, staticRenderFns }